import CLogin from "./CLogin";
export * from "./CLogin";
export default CLogin;